import { useDispatch } from 'react-redux';
import { openCardById } from '../../../data/redux/slices/cardInfoDialogSlice';

/**
 * Convenience hook for opening the global card-info dialog from anywhere
 * in the app. Returns a single `open(card)` function.
 *
 * Accepts either a card id string, or a card-like object `{id, cardId,
 * name, imageUri, ...}`. The best-available info from the object is
 * passed through as the dialog's seed so the skeleton can show
 * something while the full details are in flight.
 */
export function useOpenCardInfo() {
    const dispatch = useDispatch();
    return (card) => {
        if (!card) return;
        if (typeof card === 'string') {
            dispatch(openCardById(card));
            return;
        }
        const ownId = card.id || card.cardId;
        // For modal/MDFC cards, face records carry a `containerId` pointing
        // at the pair's container card. The details endpoint only resolves
        // by front-face/container id — raw back-face ids return null — so
        // we always fetch by container when it's available and remember
        // which face the user originally clicked.
        const fetchId = card.containerId || ownId;
        if (!fetchId) return;
        dispatch(
            openCardById(fetchId, {
                name: card.name,
                imageUri: card.imageUri,
                typeLine: card.types,
                oracle: card.oracle,
                manaCost: card.mana_cost || card.manaCost,
                preferredFaceId: ownId,
            })
        );
    };
}
